export default {
    bloglist: {
        en: [
            {
                title: 'How to Download GBWhatsApp Latest Version',
                poster: require('@/assets/blog-1.webp'),
                desc: "GBWhatsApp latest version offers privacy, themes, and advanced messaging. Users can safely download, explore features, updates, and manage settings effectively.",
                name: 'en-download-gbwhatsapp-latest-version',
                url: '/download-gbwhatsapp-latest-version/',
                date: "2026-02-03",
            },

           
        ],
    }
    
}